import {ActionReducer, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromMessage from '../reducers/message.reducer';
import * as fromFreelancers from '../reducers/freelancer.reducer';
import {combineReducers} from '@ngrx/store';

export interface FreelancersState {
  messages: fromMessage.MessageState;
  freelancers: fromFreelancers.FreelancerState;
}

export const reducers: ActionReducerMap<FreelancersState> = {
  messages: fromMessage.reducer,
  freelancers: fromFreelancers.reducer,
};

export const reducer: ActionReducer<FreelancersState> = combineReducers(reducers);

export const getFreelancerState = createFeatureSelector<FreelancersState>('freelancersFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/reducers/index.ts